import { useMemo } from "react";

type Props = { count?: number; className?: string };

/**
 * 桜の花びらが舞う背景演出 (CSS only — Lottie 素材到着まで placeholder)。
 */
export function Sakura({ count = 14, className }: Props) {
  const petals = useMemo(
    () =>
      Array.from({ length: count }, (_, i) => ({
        id: i,
        left: `${(i * 73) % 100}%`,
        delay: `${(i * 0.7) % 8}s`,
        duration: `${6 + (i % 5) * 1.4}s`,
        size: 8 + (i % 4) * 4,
      })),
    [count],
  );

  return (
    <div
      aria-hidden
      className={`pointer-events-none absolute inset-0 overflow-hidden ${className ?? ""}`}
    >
      {petals.map((p) => (
        <span
          key={p.id}
          className="absolute -top-4 block rounded-full"
          style={{
            left: p.left,
            width: p.size,
            height: p.size * 0.6,
            background:
              "radial-gradient(ellipse at 30% 30%, rgba(255,200,210,0.95), rgba(255,170,190,0.6) 60%, transparent 70%)",
            transform: "rotate(20deg)",
            animation: `petal-fall ${p.duration} linear infinite`,
            animationDelay: p.delay,
            filter: "drop-shadow(0 0 6px rgba(255,200,210,0.4))",
          }}
        />
      ))}
    </div>
  );
}
